export default __webpack_public_path__ + "static/media/618.4104ff2f.png";